module.exports = __webpack_public_path__ + "media/images/flags/64/Unknown-1b5e04530fdd4bbef6140132c9c97987.png";